import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const presentation_participations = {

  namespaced: true,

  state: {
    participations: [],
    all: null,
  },

  getters: {
    participations: state => state.participations,
    all: state => state.all,
  },

  mutations: {
    setParticipations(state, participations) { state.participations = participations },
    setAll(state, all) { state.all = all },
  },

  actions: {

    async getParticipations({ commit }) {
      const participations = await Vue.axios.get(API_URL + '/presentations/' + router.currentRoute.params.id + '/participations')
      commit('setProgress', false, { root: true });
      commit('setParticipations', participations.data);
    },

    async updateState({ state, commit }, values) {
      const participation = await Vue.axios.put(API_URL + '/participations/' + values.id, { state_id: values.state_id });
      state.participations[values.skey].presentations[values.ckey].presentation.persons[values.pkey].participation.state_id = participation.data.state_id;
      commit('setProgress', false, { root: true });
    },

    async updateStates({ state, commit }, values) {
      const participations = await Vue.axios.put(API_URL + '/presentations/' + router.currentRoute.params.id + '/participations', { state_id: values.state_id });
      if (state.participations && state.participations.length > 0) {
        for (let i = 0; i < state.participations.length; i++) {
          for (let j = 0; j < state.participations[i].presentations.length; j++) {
            if (state.participations[i].presentations[j].presentation.persons && state.participations[i].presentations[j].presentation.persons.length > 0) {
              for (let k = 0; k < state.participations[i].presentations[j].presentation.persons.length; k++) {
                state.participations[i].presentations[j].presentation.persons[k].participation.state_id = participations.data.state_id;
              }
            }
          }
        }
      }
      commit('setAll', null);
      commit('setProgress', false, { root: true });
    },

  }
}
